/**
 * useRuleActions — wraps archive / validate / triggerCycle actions
 * from the playbooks store with the current playbook_id baked in.
 */

import { usePlaybooksStore } from '@/stores/playbooks';

export function useRuleActions(playbookId: string | undefined) {
  const archiveRule = usePlaybooksStore((s) => s.archiveRule);
  const validateRule = usePlaybooksStore((s) => s.validateRule);
  const triggerCycle = usePlaybooksStore((s) => s.triggerCycle);
  const pendingRuleAction = usePlaybooksStore((s) => s.pendingRuleAction);
  const triggerInFlight = usePlaybooksStore((s) => s.triggerInFlight);
  const lastActionMessage = usePlaybooksStore((s) => s.lastActionMessage);

  return {
    pendingRuleAction,
    triggerInFlight,
    lastActionMessage,
    archive: (ruleId: string, note?: string) =>
      playbookId ? archiveRule(playbookId, ruleId, note) : null,
    validate: (ruleId: string, note?: string) =>
      playbookId ? validateRule(playbookId, ruleId, note) : null,
    trigger: () => (playbookId ? triggerCycle(playbookId) : null),
  };
}
